import apiClient from './client';

export async function getNotificationSettings() {
  const response = await apiClient.get('/settings/notifications');
  return response.data;
}

export async function updateNotificationSettings(payload) {
  const response = await apiClient.put('/settings/notifications', payload);
  return response.data;
}

export async function getUserPreferences() {
  const response = await apiClient.get('/settings/preferences');
  return response.data;
}

export async function updateUserPreferences(payload) {
  const response = await apiClient.put('/settings/preferences', payload);
  return response.data;
}

export async function getActiveSessions() {
  const response = await apiClient.get('/auth/sessions');
  return response.data;
}

export async function revokeAllSessions() {
  const response = await apiClient.delete('/auth/sessions');
  return response.data;
}

export async function deactivateAccount(payload) {
  const response = await apiClient.post('/auth/deactivate', payload);
  return response.data;
}
